const EXPORTABLE_DATA_URL = /^data:image\/(png|jpe?g);/i

export const isPngDataUrl = (src: string): boolean => /^data:image\/png/i.test(src)

export const isExportableDataUrl = (src: string): boolean => EXPORTABLE_DATA_URL.test(src)

function blobToDataUrl(blob: Blob): Promise<string | null> {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(typeof reader.result === 'string' ? reader.result : null)
    reader.onerror = () => resolve(null)
    reader.readAsDataURL(blob)
  })
}

export function loadImage(src: string): Promise<HTMLImageElement | null> {
  return new Promise(resolve => {
    const image = new Image()
    image.onload = () => resolve(image)
    image.onerror = () => resolve(null)
    image.src = src
  })
}

async function rasterizeToPng(src: string): Promise<string | null> {
  const image = await loadImage(src)
  if (!image) return null
  const canvas = document.createElement('canvas')
  canvas.width = image.naturalWidth || 1
  canvas.height = image.naturalHeight || 1
  const context = canvas.getContext('2d')
  if (!context) return null
  context.drawImage(image, 0, 0)
  return canvas.toDataURL('image/png')
}

export async function toExportableImage(src: string): Promise<string | null> {
  try {
    let dataUrl: string | null = src
    if (!src.startsWith('data:')) {
      const response = await fetch(src, { mode: 'cors' })
      if (!response.ok) return null
      dataUrl = await blobToDataUrl(await response.blob())
    }
    if (!dataUrl) return null
    return isExportableDataUrl(dataUrl) ? dataUrl : await rasterizeToPng(dataUrl)
  } catch {
    return null
  }
}
